module.exports = __webpack_public_path__ + "img/6a4e757d4a5499678127c5a1cdeec703.gif";